import { useSearchParams } from "react-router-dom";

// `?tab=` is the source of truth so a tab can be linked and survives a refresh.
// An unknown tab (or one hidden for this brand, e.g. debit notes on self-payout)
// falls back to the first tab.
const useActiveTab = (tabs) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const requestedTab = searchParams.get("tab");
    const activeTab = tabs.some((tab) => tab.id === requestedTab) ? requestedTab : tabs[0].id;

    const setActiveTab = (tab) => setSearchParams({ tab }, { replace: true });

    return { activeTab, setActiveTab };
};

export default useActiveTab;
